import { useContext } from "react";
import CartContext from "../../context/cart";
import CartSummary from "./cart-summary";

const CartThirdStream = ({ secondPhase = false }) => {
  const { labels } = useContext(CartContext);

  return (
    <>
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html: secondPhase
            ? labels?.WELFARE_CART_HOME_DELIVERY_TEXT_SLOT_BOOKING
            : labels?.WELFARE_CART_HOME_DELIVERY_TEXT ||
              "<p>You should already have inserted your shipping address on a different platform.</p><p>For further information please contact the Welfare Team:  <a href='mailto:welfare@essilorluxottica.com'>welfare@essil rluxottica.com</a></p>",
        }}
      />
      {!secondPhase && <CartSummary variant="reminder" readOnly={true} />}
    </>
  );
};

export default CartThirdStream;
